import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { cancelConfirm } from 'redux/navigation'
import { loadProperties } from 'redux/properties'
import { loadBreadcrumbs, loadRoute, loadTree } from 'redux/routes'
import { Grid, Header } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { route } = state.routes
  return { route }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadTree,
      loadRoute,
      loadBreadcrumbs,
      loadProperties,
    },
    dispatch
  )
}

class RoutesAdmin extends React.Component {
  componentWillMount() {
    const { params } = this.props
    const { loadRoute } = this.props
    params && params.id && loadRoute(params.id)

    const { loadTree, loadBreadcrumbs, loadProperties } = this.props
    loadTree()
    loadBreadcrumbs()
    loadProperties()
  }

  componentWillReceiveProps(nextProps) {
    const { cancelConfirm } = this.props
    const {
      keydown: { event },
    } = nextProps
    if (event) {
      cancelConfirm()
    }
  }

  render() {
    return (
      <Grid stackable>
        <Grid.Row columns={2}>
          <Grid.Column
            tablet={12}
            computer={12}
            largeScreen={12}
            widescreen={2}
            className="stacked top up-to-largeScreen">
            <Header as="h1">RoutesBrowser</Header>
          </Grid.Column>
          <Grid.Column
            tablet={12}
            computer={12}
            largeScreen={12}
            widescreen={10}
            className="stacked"
          />
        </Grid.Row>
      </Grid>
    )
  }
}

RoutesAdmin = connect(mapStateToProps, mapDispatchToProps)(RoutesAdmin)
export default RoutesAdmin



// WEBPACK FOOTER //
// ./src/containers/admin/routes.jsx